module.exports = __webpack_public_path__ + "static/media/plat.ae22febf.svg";